<script setup lang="ts">
const props = defineProps<{
	content: HTMLElement | null;
}>();

const { arrivedState, measure } = useScroll(() => props.content, {
	throttle: 100,
});

const showRightGrient = computed(() => !arrivedState.right);
const showLeftGrient = computed(() => !arrivedState.left);

const { width } = useElementSize(() => props.content);
watch(width, measure);
</script>

<template>
	<div
		:class="[
			// Always hidden on desktop
			'md:hidden',
			// Display state
			showRightGrient ? 'opacity-100' : 'opacity-0',
			// Position
			'pointer-events-none absolute bottom-0 right-0 top-0 w-12',
			// Transition
			'transition-opacity duration-200',
			// Gradient
			'from-base-300 bg-gradient-to-l to-transparent',
		]"
	/>
	<div
		:class="[
			// Always hidden on desktop
			'md:hidden',
			// Display state
			showLeftGrient ? 'opacity-100' : 'opacity-0',
			// Position
			'pointer-events-none absolute bottom-0 left-0 top-0 w-12',
			// Transition
			'transition-opacity duration-200',
			// Gradient
			'from-base-300 bg-gradient-to-r to-transparent',
		]"
	/>
</template>
